<!-- 调拨单编辑页面 -->
<template>
    <div class="business-content-main trans-info" v-loading="tloading">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">调出仓库</div>
                <el-select
                    v-model="subData.OutWarehouseId"
                    :loading="loading"
                    class="search-item"
                    size="small"
                    filterable
                    clearable
                    :disabled="dataReadonly || type != 3"
                    @change="handleChange"
                >
                    <el-option v-for="optionItem in WarehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <el-button size="small" class="search-btn btn-primary" icon="el-icon-search" @click="showSearch" v-if="type == 3 || type == 2 || type == 4"
                    >选择调出配件</el-button
                >
                <div class="search-name">调出成本</div>
                <el-input-number
                    type="number"
                    class="search-item"
                    :min="0"
                    :precision="2"
                    controls-position="right"
                    size="small"
                    v-model="tranCost"
                    :disabled="dataReadonly || type != 3"
                ></el-input-number>
                <div class="search-name" v-if="!(dataReadonly || type != 3)">分摊成本</div>
                <el-select class="search-item" v-model="calcType" size="small" v-if="!(dataReadonly || type != 3)">
                    <el-option v-for="item in calcTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <el-input-number
                    type="number"
                    class="search-item"
                    :min="0"
                    :precision="2"
                    controls-position="right"
                    size="small"
                    v-model="point"
                    :step="0.1"
                    v-if="calcType == 2"
                ></el-input-number>
                <el-button size="small" class="search-btn btn-primary" @click="calcShare()" v-if="isCalcFirst && !(dataReadonly || type != 3)">计算分摊</el-button>
                <el-button size="small" class="search-btn" type="warning" @click="recoverCalc()" v-if="!isCalcFirst && !(dataReadonly || type != 3)"
                    >恢复计算前</el-button
                >
                <div class="search-name" style="color: red">（※成本价计算分摊后一旦保存，将无法再恢复到原有的成本价，但不影响商品数据！）</div>
            </div>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">调入仓库</div>
                <el-select
                    v-model="subData.InWarehouseId"
                    :disabled="dataReadonly || type != 3"
                    :loading="loading"
                    class="search-item"
                    size="small"
                    filterable
                    clearable
                    @change="InWarehouseChange"
                >
                    <el-option v-for="optionItem in InWarehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">调仓备注</div>
                <el-input class="search-item" size="small" style="width: 600px" v-model="subData.Remark" :readonly="dataReadonly"></el-input>
                <el-button size="small" class="search-btn btn-primary" @click="save()" v-if="type == 2 || type == 3 || type == 4" :disabled="saving"
                    >保存调仓单</el-button
                >
                <el-button size="small" class="search-btn btn-primary" @click="saveAndAdd()" v-if="type == 2 || type == 3" :disabled="saving">保存并继续新增</el-button>
            </div>
        </div>
        <div class="data-result" id="infinite-list">
            <div class="section-title">
                <div class="sec-item">调拨商品清单</div>
            </div>
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteListHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                highlight-current-row
                @row-click="rowClick"
                :row-class-name="tableRowClassName"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" show-overflow-tooltip resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="div-padding-12">
                            <span class="sp-i" v-show="row.APCode">
                                <i title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode }}</span>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="GoodName" title="配件名称" show-overflow-tooltip>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.GoodName }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="AutoSeriseItem" title="车型" show-overflow-tooltip>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.AutoSerise }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Cate" title="分类" width="80" key="12">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Cate }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" width="80" key="13">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" width="80" key="origin" v-if="!funcConfig">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Origin }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Unit" title="单位" width="70" key="6">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Unit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="SalePrice" title="参考售价" width="100" key="7" v-if="funcConfig">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <span>
                                <img
                                    src="@/assets/images/cus.png"
                                    style="width: 25px; height: 25px; margin-right: 4px"
                                    title="销售历史"
                                    v-if="row.EntpTempGoodsId"
                                    @click.stop="showHistoryDialog(row.EntpTempGoodsId)"
                                />
                            </span>
                            <span>
                                {{ row.ReferencePrice }}
                            </span>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="OriginalCount" title="当前在库数" width="100" key="14">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.OriginalCount }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Count" title="调出数量" width="100" key="5" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input
                                ref="countRef"
                                size="small"
                                type="number"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                :disabled="type == 1"
                                @keyup.right.native="keyEvent($event, 'Count', scope.row, scope.rowIndex)"
                                @focus="selectAutoHandle('countRef')"
                            ></el-input>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="CostPrice" title="成本价" width="100" key="costprice" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.CostPrice || row.CostPrice === 0 }]">
                            {{ row.CostPrice }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input
                                type="number"
                                size="small"
                                ref="priceRef"
                                v-model="scope.row.CostPrice"
                                @input="priceChange"
                                placeholder="成本价"
                                :disabled="type == 1"
                                @keyup.left.native="keyEvent($event, 'CostPrice', scope.row, scope.rowIndex)"
                                @focus="selectAutoHandle('priceRef')"
                            ></el-input>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column title="调出总额" width="100" key="dcze">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ ((row.Count?row.Count:0 )* (row.CostPrice?row.CostPrice:0)).toFixed(2) }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column title="调出仓位" width="100" key="outspace" v-if="type == 1">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <span>
                                {{  row.OutSpaceList && row.OutSpaceList.length > 0 ? row.OutSpaceList[0] : '未出仓' }}
                                <el-tooltip placement="right">
                                    <div slot="content" v-html="$options.filters.SpaceTextSplit(row.OutSpaceList)"></div>
                                    <img
                                        src="@/assets/images/more.png"
                                        style="width: 22px; height: 22px; margin-left: 4px"
                                        title="查看更多"
                                        v-if=" row.OutSpaceList && row.OutSpaceList.length > 1"
                                    />
                                </el-tooltip>
                            </span>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column title="调入仓位" width="100" key="inspace" v-if="type == 1">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <span>
                                {{  row.InSpaceList && row.InSpaceList.length > 0 ? row.InSpaceList[0] : '未入仓' }}
                                <el-tooltip placement="right">
                                    <div slot="content" v-html="$options.filters.SpaceTextSplit(row.OutSpaceList)"></div>
                                    <img
                                        src="@/assets/images/more.png"
                                        style="width: 22px; height: 22px; margin-left: 4px"
                                        title="查看更多"
                                        v-if=" row.InSpaceList && row.InSpaceList.length > 1"
                                    />
                                </el-tooltip>
                            </span>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column title="操作" width="70" key="11" v-if="!dataReadonly">
                    <template v-slot="{ rowIndex }">
                        <div class="operate" v-if="!dataReadonly">
                            <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete"></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeHistoryDialog"></APHistory>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog
            :close-on-click-modal="false"
            :title="title"
            :visible.sync="searchVisible"
            width="1200px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-db-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -500px"
        >
            <div v-if="searchVisible">
                <searchAPFilterWH :StorageId="subData.OutWarehouseId" @closeDialog="closeSearchDialog" :IsShowRePrice="funcConfig"></searchAPFilterWH>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import searchAPFilterWH from '@/components/common/searchAPFilterWH';
import breadcrumb from '@/components/common/breadcrumb';
import APHistory from '@/components/common/APHistory';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb,
        APHistory,
        searchAPFilterWH,
        APMsg
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isTransNumSet: false,
            needConfirm: true,
            tloading: false,
            title: '',
            searchVisible: false,
            saving: false, //保存中，表示不可再次保存
            userMsg: userMsg,
            showAddBtn: false,
            type: '',
            pageTitle: '',
            orderState: -1,
            dataReadonly: false,
            loading: false,
            EntpTempGoodsIdEdit: '',
            historyVisible: false,
            oldOutWarehouseId: '',
            tranCost: 0,
            subData: {
                UserId: userMsg.EmployeeId,
                ToId: '', // 调拨单id
                OutWarehouseId: '',
                InWarehouseId: '', // 调入仓位id
                Remark: '',
                TranCost: 0,
                DetailList: []
            },
            brandList: [],
            cateList: [],
            nameList: [], //这个字段用于保存原仓拥有的商品数据
            codeList: [],
            dataList: [],
            WarehouseList: [],
            InWarehouseList:[],
            infiniteListHeight: '', // 表格高度
            allNum: 0,
            allMoney: 0,
            funcConfig: false,
            APMsgVisible: false,
            calcType: -1,
            calcTypeList: [
                { Text: '请选择', Value: -1 },
                { Text: '按价值分摊', Value: 0 },
                { Text: '按数量分摊', Value: 1 },
                { Text: '按点数直接调整', Value: 2 }
            ],
            point: 1,
            isCalcFirst: true,
            recoverList: [],
            dataindex: -1
        };
    },
    filters: {
        SpaceTextSplit(x) {
            return x.join('<br/>');
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.type = this.$route.query.type;
        this.getConfigByCodes();
        if (this.type == 1) {
            this.pageTitle = '查看调拨单';
            this.dataReadonly = true;
            this.subData.TOId = this.$route.query.TOId;
            this.getTableData();
        } else if (this.type == 2) {
            this.pageTitle = '编辑调拨单';
            this.subData.TOId = this.$route.query.TOId;
            this.getTableData();
        } else if (this.type == 3) {
            this.pageTitle = '新增调拨单';
            this.getWarehouse();
            this.getInWarehouse();
        } else if (this.type == 4) {
            this.pageTitle = '修改调拨单';
            this.subData.TOId = this.$route.query.TOId;
            this.getTableData();
        }
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;
            //上键
            if (key == 38) {
                if (!that.searchVisible && !that.APMsgVisible && !that.historyVisible) {
                    if (that.dataindex > 0) {
                        that.dataindex--;
                        let index = that.dataindex;
                        that.$nextTick(() => {
                            if (that.$refs.infiniteTable) {
                                that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                                that.$refs.infiniteTable.setActiveRow(that.$refs.infiniteTable.data[index]);
                            }
                        });
                    }
                }
            }
            //下键
            if (key == 40) {
                if (!that.searchVisible && !that.APMsgVisible && !that.historyVisible) {
                    if (that.dataindex != that.dataList.length - 1) {
                        that.dataindex++;
                        let index = that.dataindex;
                        that.$nextTick(() => {
                            if (that.$refs.infiniteTable) {
                                that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                                that.$refs.infiniteTable.setActiveRow(that.$refs.infiniteTable.data[index]);
                            }
                        });
                    }
                }
            }
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top - 80;
        },
        //重新打开新增页面
        reload() {
            let that = this;
            that.getWarehouse();
            that.getInWarehouse();
            that.$router.push({ query: { type: 3, TOId: '' } });
            that.pageTitle = '新增调拨单';
            that.subData.TOId = '';
            that.showAddBtn = false;
            that.type = 3;
            that.nameList = [];
            that.codeList = [];
            that.dataList = [];
            that.subData = {
                UserId: that.userMsg.EmployeeId,
                ToId: '',
                OutWarehouseId: '',
                InWarehouseId: '',
                Remark: '',
                DetailList: []
            };
            that.saving = false;
            that.allNum = 0;
            that.allMoney = 0;
        },
        // 保存调仓单
        save(gotoAdd) {
            let that = this;
            let _list = that.dataList;
            if (!that.dataList[0]) {
                that.$util.warningMsg('请添加配件');
                return;
            }
            if (!that.subData.OutWarehouseId) {
                this.$util.warningMsg('请选择调出仓库');
                return;
            }
            if (!that.subData.InWarehouseId) {
                this.$util.warningMsg('请选择调入仓库');
                return;
            }
            for (let i = 0; i < _list.length; i++) {
                if (!_list[i].APCode) {
                    that.$util.warningMsg('请选择配件');
                    return;
                }
                if (_list[i].Count > _list[i].OriginalCount) {
                   that.$util.warningMsg(`第【${i+1}】项${_list[i].GoodName}【${_list[i].APCode}】调出数量不得大于库存数量`);
                    return;
                }
            }
            if (that.saving) return;

            that.saving = true;
            that.subData.TranCost = that.tranCost;
            that.subData.DetailList = that.dataList;
            that.subData.DetailList.forEach((e, i) => {
                e.SortNum = i + 1;
            });
            that.subData.UserId = that.userMsg.EmployeeId;
            let url = '/api/EntpTransferOrder/NewSaveEnterpriseTransferOrder';
            if (that.type == 4) url = '/api/EntpTransferOrder/SaveTransferOrderAfterSubmit';
            that.needConfirm = false;
            that.$util
                .axiosPost({
                    url: url,
                    data: that.subData
                })
                .then(res => {
                    if (that.type == 3) that.$util.successMsg('调拨单创建成功');
                    else that.$util.successMsg('调拨单保存成功');
                    that.$store.commit('updateNeedRefresh', true);
                    if (gotoAdd) {
                        setTimeout(() => {
                            that.reload();
                        }, 300);
                    } else {
                        setTimeout(() => {
                            that.$router.push('/inventoryManage/transWarehouse');
                        }, 1000);
                    }
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        // 保存并添加调仓单
        saveAndAdd() {
            this.save(true);
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dbdzscksjl', 'dmslmr'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dbdzscksjl':
                                    this.funcConfig = result;
                                    break;
                                case 'dmslmr': //调拨默认数赋值为1
                                    this.isTransNumSet = result;
                                    break;  
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 编辑&查看时获取列表
        getTableData() {
            this.tloading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/NewGetEntpTransOrderDetail',
                    data: {
                        TOId: this.subData.TOId,
                        Type:this.type
                    },
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    //这里这样做是为了防止select控件没有数据，现有绑定值，而导致页面展现出id
                    this.WarehouseList = [
                        {
                            WarehouseId: data.OutWarehouseId,
                            WarehouseName: data.OutWarehouseName
                        }
                    ];

                    this.InWarehouseList.push({
                        WarehouseId: data.InWarehouseId,
                        WarehouseName: data.InWarehouseName
                    });

                    this.subData = data;
                    this.dataList = data.DetailList;
                    this.tranCost = data.TranCost;
                    this.orderState = data.State;
                    if (this.type == 1) {
                        this.dataReadonly = true;
                    }
                    this.priceChange();
                })
                .finally(() => {
                    this.tloading = false;
                });
        },
        // 调入仓库发生改变
        InWarehouseChange(value) {
            if (value &&value == this.subData.OutWarehouseId) {
                this.subData.InWarehouseId = '';
                this.$util.warningMsg('调入仓库和调出仓库不能相同');
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        getInWarehouse() {
            this.$util.getWarehouseNotAuth(1).then(data => {
                this.InWarehouseList = data;
            });
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.checkshowAll();
            this.priceChange();
        },
        // 校验是否已选中全部商品
        checkshowAll() {
            let _target = this.dataList;
            let _origin = this.nameList;
            if (_target.length < _origin.length) {
                this.showAddBtn = true;
                let arr = Array.from(new Set([..._origin].filter(x => !_target.some(y => y.APCode == x.APCode))));
                this.codeList = arr;
            } else {
                this.showAddBtn = false;
            }
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        handleChange(val) {
            var obj = {};
            let that = this;
            if (that.subData.InWarehouseId && that.subData.InWarehouseId === val) {
                that.subData.InWarehouseId = '';
                that.$util.warningMsg('调入仓库和调出仓库不能相同');
            }

            if (that.dataList.length > 0) {
                that.$confirm('修改原有调出仓库会清空已选择的商品，您确定要修改吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    distinguishCancelAndClose: true,
                    closeOnClickModal: false,
                    type: 'warning'
                })
                    .then(() => {
                        if (val) {
                            obj = that.WarehouseList.find(function(item) {
                                return item.WarehouseId === val;
                            });
                            that.subData.OutWarehouseName = obj.WarehouseName;
                        } else {
                            that.subData.OutWarehouseName = '';
                        }

                        that.dataList = [];
                        that.recoverList = [];
                    })
                    .catch(() => {
                        that.subData.OutWarehouseId = that.oldOutWarehouseId;
                    });
            } else {
                that.oldOutWarehouseId = val;
                if (val == '') {
                    that.subData.OutWarehouseName = '';
                } else {
                    obj = that.WarehouseList.find(function(item) {
                        return item.WarehouseId === val;
                    });
                    that.subData.OutWarehouseName = obj.WarehouseName;
                }
            }
        },
        showSearch() {
            if (this.subData.OutWarehouseId) {
                this.title = '选择仓库【' + this.subData.OutWarehouseName + '】下的商品进行调拨';
                this.searchVisible = true;
            } else {
                this.$util.warningMsg('请先选择要调出的仓库');
            }
        },
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }

            //将相同的商品的数量合并
            let filterItemList = [];
            let recoverItemList = [];
            itemList.forEach((item, i) => {
                //如果已存在当前页面,则累加，在后台判断真实数量 .
                let data = that.dataList.find(e => e.EntpTempGoodsId == item.EntpTempGoodsId);
                if (!data) {
                    if(that.isTransNumSet)
                         item.Count = 1;
                    filterItemList.push(item);
                    let coverData = { ...item };
                    recoverItemList.push(coverData);
                }
            });
            if (filterItemList.length > 0) that.dataList = that.dataList.concat(filterItemList);

            if (recoverItemList.length > 0) that.recoverList = that.recoverList.concat(recoverItemList);

            that.priceChange();
            that.checkshowAll();
        },
        setSummaries() {
            return [['', '', '', '', '', '', '', '', '总数量', this.allNum, '合计', this.allMoney.toFixed(3)]];
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].CostPrice ? (DetailList[i].Count * DetailList[i].CostPrice).toFixed(2) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = DetailList;
        },
        calcShare() {
            let that = this;
            if (that.calcType == 2) {
                if (that.isCalcFirst) {
                    that.isCalcFirst = false;
                    if (that.point) {
                        that.dataList.forEach(item => {
                            item.CostPrice = (item.CostPrice * that.point).toFixed(2);
                        });
                    } else that.$message.error('计算的点数异常，请重新填写');
                }
                return;
            } else if ((that.calcType == 1 || that.calcType == 0) && that.tranCost != 0) {
                if (that.isCalcFirst) {
                    that.isCalcFirst = false;
                    let list = that.dataList;
                    let costTotal = that.tranCost;
                    let supTotal = 0;
                    let supCount = 0;
                    list.forEach(item => {
                        supTotal += item.CostPrice;
                        supCount += item.Count;
                    });
                    that.dataList.forEach(item => {
                        if (that.calcType == 0) {
                            item.CostPrice = (item.CostPrice + Number((item.CostPrice * (costTotal / supTotal)) / item.Count)).toFixed(2);
                        } else {
                            item.CostPrice = (item.CostPrice + Number(costTotal / supCount)).toFixed(2);
                        }
                    });
                }
                return;
            } else {
                that.$message.error('未检测到要计算的分摊的成本');
                return;
            }
        },
        recoverCalc() {
            let that = this;
            that.dataList.forEach(item => {
                let data = that.recoverList.find(e => e.EntpTempGoodsId == item.EntpTempGoodsId);
                item.CostPrice = data.CostPrice;
            });
            that.isCalcFirst = true;
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                if (code == 'CostPrice') {
                    if (that.$refs[`countRef`]) that.$refs[`countRef`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    if (that.$refs[`priceRef`]) that.$refs[`priceRef`].focus();
                }
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            //每次点击搜索配件后打开弹窗，select()事件没效果，有可能初始化控件后这个事件还没监听到input控件
            //所以这里用来nextTick 和 setTimeout做双重保证
            this.$nextTick(() => {
                // this.$refs[ref].select();
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        }
    }
};
</script>
<style lang="less" scoped>
// .checkbtn {
// }
.search-ctn {
    min-height: 0px;
}
.form-main {
    display: flex;
    > div {
        width: 33.33%;
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: flex-start;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    margin-left: -1px;
    margin-right: 1px;
    background: @border3Color;
}
.sec-item {
    margin-right: 10px;
    font-size: 16px;
    font-weight: 700;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;
}
.add-btn {
    position: absolute;
    right: -42px;
    bottom: -40px;
    height: 40px;
    width: 40px;
}
.less-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -30px;
    top: 5px;
    z-index: 2;
    height: 28px;
    width: 28px;
}
.business-content-main {
    padding-right: 20px;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 36px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
}
.history-main {
    position: absolute;
    left: 0;
    width: 100%;
    height: 140px;
    overflow: auto;
    padding: 10px;
    border: 1px solid @border3Color;
    background: white;
    z-index: 2;
    .history-row {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
            background: @border3Color;
        }
        > div {
            text-align: center;
            line-height: 30px;
        }
    }
}
.history-no-data {
    text-align: center;
    font-size: 26px;
    line-height: 100px;
}
.data-result {
    margin-bottom: 30px;
}
.sp-i {
    height: 24px;
    margin-left: -6px;
    margin-right: 2px;
}
.el-icon-info {
    color: #87a7d6;
    font-size: 18px;
    vertical-align: top;
    cursor: pointer;
    margin-top: 2px;
    margin-right: 3px;
}
</style>
<style lang="less">
.trans-info {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body {
            .elx-body--row {
                .elx-body--column:first-child {
                    .elx-cell {
                        padding: 4px 10px 0;
                    }
                }
            }
        }
        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;
            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 4px;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }

    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    input::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
    }

    input[type='number'] {
        -moz-appearance: textfield;
    }
}
#search-db-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
